export type WebContextPayload = {
  [key: string]: string | number | boolean | undefined;
};

export type WebContextResponse = {
  success: boolean;
  webContextId?: string;
};

export const fetchWebContextId = async (
  payload: WebContextPayload,
): Promise<{ webContextId?: string; error?: string }> => {
  try {
    const response = await fetch(`${process.env.NEXT_PUBLIC_SERVICE_URL}/v1/webcontext`, {
      method: 'POST',
      cache: 'no-cache',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      return { error: `WebContext API request failed with status ${response.status}` };
    }

    const data: WebContextResponse = await response.json();

    if (!data.success || !data.webContextId) {
      return { error: 'Failed to get web context ID' };
    }

    return { webContextId: data.webContextId };
  } catch (error) {
    console.error('WebContext fetch error:', error);
    return { error: 'Failed to get web context ID' };
  }
};
